export default __webpack_public_path__ + "static/media/Aura-Egg__52.a77c060d.png";